/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A4Inputs */

const en_to_typescript_faq_a4 = /** @type {(inputs: To_Typescript_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They become a union of the observed element types. An array holding strings and numbers is typed (string | number)[]. An empty array becomes any[], because there is nothing to infer an element type from.`)
};

const ko_to_typescript_faq_a4 = /** @type {(inputs: To_Typescript_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관찰된 요소 타입들의 유니온이 됩니다. 문자열과 숫자를 담은 배열은 (string | number)[]로 타입이 붙습니다. 빈 배열은 요소 타입을 추론할 근거가 없으므로 any[]가 됩니다.`)
};

const ja_to_typescript_faq_a4 = /** @type {(inputs: To_Typescript_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`観測された要素型のユニオンになります。文字列と数値を持つ配列は (string | number)[] と型付けされます。空の配列は要素型を推論する根拠がないので any[] になります。`)
};

/**
* | output |
* | --- |
* | "They become a union of the observed element types. An array holding strings and numbers is typed (string \| number)[]. An empty array becomes any[], because t..." |
*
* @param {To_Typescript_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a4 = /** @type {((inputs?: To_Typescript_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a4(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a4(inputs)
	return ja_to_typescript_faq_a4(inputs)
});